import { LOCALE } from '@hhgtech/hhg-components/types'

export const DEFAULT_FONT_LIST = [
  '/fonts/inter/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7W0Q5n-wU.woff2',
  '/fonts/inter/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7W0Q5n-wU.woff2',
  '/fonts/inter/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7W0Q5n-wU.woff2',
  '/fonts/inter/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7W0Q5n-wU.woff2',
  '/fonts/inter/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7W0Q5n-wU.woff2',
  '/fonts/inter/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7W0Q5n-wU.woff2',
  '/fonts/inter/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2',
]

export const MAPPED_FONT_LIST: {
  [locale in LOCALE]?: string[]
} = {
  [LOCALE.Cambodia]: [
    '/fonts/battambang/uk-mEGe7raEw-HjkzZabPnmp4g5y_o5z7Q.woff2',
    '/fonts/battambang/uk-mEGe7raEw-HjkzZabPnKp4g5y_o4.woff2',
    '/fonts/battambang/uk-lEGe7raEw-HjkzZabNsmM9yhQ86RJ5IxcMg.woff2',
    '/fonts/battambang/uk-lEGe7raEw-HjkzZabNsmM9yNQ86RJ5Iw.woff2',
  ],
  [LOCALE.Thailand]: [
    '/fonts/notoSansThai/iJWdBXeUZi_OHPqn4wq6hQ2_hZht786_Um0wZ4Y.woff2',
    '/fonts/notoSansThai/iJWdBXeUZi_OHPqn4wq6hQ2_hZh3786_Um0wZ4Y.woff2',
    '/fonts/notoSansThai/iJWdBXeUZi_OHPqn4wq6hQ2_hZh5786_Um0w.woff2',
  ],
}
